import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import "./component-styles.scss";
import closeIcon from "../../assets/common/closeWithText.png";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import swal from "sweetalert";
import Loader from "../UI Component/Loader/Loader";
import CallInitiatedModal from "./CallInitiatedModal";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

function CallModal({
  openView,
  closeView,
  modalCloseView,
  patientName,
  appointment_id,
}) {
  const [loading, setLoading] = useState(false);
  const [openCallInitiatedView, setOpenCallInitiatedView] = useState(false);
  const [openCallInitiatedCloseView, setOpenCallInitiatedCloseView] =
    useState(false);

  let is_staff = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  function callByPhone() {
    setLoading(true);
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/doctor-call-patient",
      headers: {
        Authorization: localStorage.getItem("id_token"),
      },
      data: {
        user_type: localStorage.getItem("user_type"),
        user_id: `${is_staff === "staff" ? staffId : userId}`,
        appointment_id: appointment_id,
      },
    })
      .then((response) => {
        setLoading(false);
        if (response.data.statusCode === 200) {
          modalCloseView(false);
          closeView(false);
          setOpenCallInitiatedView(true);
          setTimeout(() => {
            setOpenCallInitiatedView(false);
          }, 5000);
        } else if (response.data.statusCode === 504) {
          modalCloseView(false);
          closeView(false);
          swal({
            title: "Something went wrong!",
            text: response.message,
            type: "failed",
            icon: "warning",
          }).then(function () {});
        } else {
          modalCloseView(false);
          closeView(false);
          swal({
            title: "Something went wrong!",
            text: response.message,
            type: "failed",
            icon: "warning",
          }).then(function () {});
        }
      })
      .catch((err) => C2CConsole.log(err));
  }

  function errorCloseMoalHandler() {
    C2CConsole.log("hjgjgkjgkhlhlhl");
  }

  return (
    <>
      {loading && <Loader />}
      {openView && (
        <>
          <Modal open={openView} onClose={closeView}>
            <div className="d-flex align-items-center justify-content-center h-100">
              <div className="call-patient-moodal-wrapper">
                <div className="call-modal">
                  <div className="header">
                    <h5>Call Patient</h5>
                    <img
                      src={closeIcon}
                      alt="closeicon"
                      onClick={closeView}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                  <div className="custom-border"></div>
                  <p style={{ display: "flex", alignItems: "center" }}>
                    <i
                      className="fa fa-user mr-2"
                      style={{ color: "#F969A4", fontSize: "17px" }}
                    ></i>
                    <span className="call_patientname">{patientName}</span>
                  </p>
                  <div className="custom-border"></div>
                  <p>
                    Now you can call patients before or during the consultation.
                    Your mobile number will not be visible.
                  </p>
                  <p style={{ fontSize: "12px" }}>
                    Note: This will not mark the appointment as success. Use
                    this feature for communication purpose only.
                  </p>
                  <div className="custom-btn-div">
                    <button
                      type="button"
                      className="btn  border rounded-pill custom-btn cursor-pointer"
                      onClick={callByPhone}
                    >
                      <div className="call-icon-div">
                        <h4 data-tooltip="Call Patient" data-tooltip-conf="top">
                          <a className="primary cursor-pointer">
                            <i
                              class="fa fa-phone call-icon"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </h4>
                      </div>
                      <div style={{ color: "#10a74a" }}>Call By Phone</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </>
      )}
      <CallInitiatedModal
        openCallInitiatedView={openCallInitiatedView}
        openCallInitiatedCloseView={openCallInitiatedCloseView}
      />
    </>
  );
}

export default CallModal;
